export default __webpack_public_path__ + "static/media/330_store01-fr-web.0de1c2dc.png";